// four cards slider  
  const swiperFourCards = new Swiper('.four__cards__slider', {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 'auto',
    speed: 800,
    watchSlidesProgress: true,
    pagination: {
      el: ".four__cards-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".four__cards-next",
      prevEl: ".four__cards-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
    autoplay: {
      delay: 3000, 
      disableOnInteraction: false,
    },
});